import type {SearchCriteriaRaw} from '../../../types';
import {createAdvancedRawRule} from '../advancedRawRule';
import type {AdvancedRawRule, TSearchTypeAdvancedRaw} from '../types';

export type RawAdvancedRawSearchCriteria =
	SearchCriteriaRaw<TSearchTypeAdvancedRaw>;

export const rawAdvancedRawCriteriaToRuleObject = (
	criteria: RawAdvancedRawSearchCriteria,
): AdvancedRawRule => {
	return createAdvancedRawRule({
		raw: criteria.value1,
	});
};

export default rawAdvancedRawCriteriaToRuleObject;
